export interface ExternalAdminFilters {
  filter?: string
  fromDate?: number // unix timestamp
  metadata?: boolean
  metaData?: boolean
  normalizeRequestContent?: boolean
  pageSize?: number
  pageIndex?: number
  offset?: number
  sorting?: string
  ascending?: string
  toDate?: number // unix timestamp
  async?: boolean
  suppressEmail?: boolean
  consistency?: 'eventual' | '' | 'strong'
  attributes?: string
  cascade?: boolean
  scheduledReport?: string
}

const externalAdminFiltersToString = ({
  filter,
  fromDate,
  metaData = true,
  metadata,
  normalizeRequestContent = true,
  pageSize,
  pageIndex,
  offset,
  sorting,
  toDate,
  consistency = 'eventual',
  async = false,
  suppressEmail,
  attributes,
  cascade,
  scheduledReport,
}: ExternalAdminFilters): string => {
  let filters = ''

  if (consistency) {
    filters += `&consistency=${consistency}`
  }

  if (pageSize) {
    filters += `&pageSize=${pageSize}`
  }
  if (offset !== undefined) {
    filters += `&offset=${offset}`
  }
  if (scheduledReport) {
    filters += `&_scheduledReport=${scheduledReport}`
  }

  if (cascade) {
    filters += `&cascade=${cascade}`
  }

  if (attributes) {
    filters += `&attributes=${attributes}`
  }

  if (pageIndex) {
    filters += `&offset=${(pageSize || 0) * pageIndex}`
  }

  if (fromDate) {
    filters += `&fromDate=${fromDate}`
  }

  if (toDate) {
    filters += `&toDate=${toDate}`
  }

  if (suppressEmail) {
    filters += `&suppressEmail=${suppressEmail}`
  }

  if (metaData) {
    filters += `&metaData=${metaData}`
  }

  // used with a lowercase in the Activity page
  if (metadata) {
    filters += `&metadata=${metadata}`
  }

  if (sorting) {
    filters += `&${sorting}`
  }

  if (normalizeRequestContent) {
    filters += `&normalizeRequestContent=${normalizeRequestContent}`
  }

  if (filter) {
    filters += `&filter=${filter}`
  }

  if (async) {
    filters += `&async=${async}`
  }

  return filters
}

export default externalAdminFiltersToString
